"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var Lang_js_1 = require("../Lang.js");
// @ts-ignore
var validator_1 = __importDefault(require("validator"));
var TextFieldDollars_1 = __importDefault(require("../Generic/TextFieldDollars"));
var HtmlEditor_1 = __importDefault(require("../Generic/HtmlEditor"));
var SeedcardForm = function (_a) {
    var onSaveSeedcard = _a.onSaveSeedcard, selectedImage = _a.selectedImage;
    var _b = (0, react_1.useState)(false), seedcardReady = _b[0], setSeedcardReady = _b[1];
    var _c = (0, react_1.useState)(''), senderName = _c[0], setSenderName = _c[1];
    var _d = (0, react_1.useState)(''), senderEmail = _d[0], setSenderEmail = _d[1];
    var _e = (0, react_1.useState)(''), recipientName = _e[0], setRecipientName = _e[1];
    var _f = (0, react_1.useState)(''), recipientEmail = _f[0], setRecipientEmail = _f[1];
    var _g = (0, react_1.useState)([]), pastRecipients = _g[0], setPastRecipients = _g[1];
    var _h = (0, react_1.useState)(''), message = _h[0], setMessage = _h[1];
    var _j = (0, react_1.useState)(true), gettingUserData = _j[0], setGettingUserData = _j[1];
    var _k = (0, react_1.useState)(true), gettingPastRecipients = _k[0], setGettingPastRecipients = _k[1];
    var _l = (0, react_1.useState)(0), donationAmount = _l[0], setDonationAmount = _l[1];
    var _m = (0, react_1.useState)(false), otherVisible = _m[0], setOtherVisible = _m[1];
    var _o = (0, react_1.useState)(''), userLogin = _o[0], setUserLogin = _o[1];
    var _p = (0, react_1.useState)(false), submitAttempted = _p[0], setSubmitAttempted = _p[1];
    var messageRef = react_1.default.createRef();
    var _q = (0, react_1.useState)(false), anonymous = _q[0], setAnonymous = _q[1];
    var scrollToMessage = function () { var _a; return (_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView(); };
    if (gettingUserData) {
        axios_1.default.get('/api/v2/students/status').then(function (response) {
            var _a;
            if (response.data['user'] === undefined) {
                setGettingUserData(false);
                return;
            }
            setSenderEmail(response.data['user']['user_email']);
            setSenderName((_a = response.data['user']['display_name']) !== null && _a !== void 0 ? _a : response.data['user']['user_nicename']);
            setUserLogin(response.data['user']['user_login']);
            setGettingUserData(false);
        }).catch(function (error) {
            setGettingUserData(false);
            console.warn(error);
        });
    }
    if (gettingPastRecipients) {
        axios_1.default.get('/api/seedcard/past_recipients').then(function (response) {
            if (response.data.length === 0) {
                setGettingPastRecipients(false);
                return;
            }
            setPastRecipients(response.data);
            setGettingPastRecipients(false);
        }).catch(function (error) {
            setGettingPastRecipients(false);
            console.warn(error);
        });
    }
    var handleDonationChange = function (e) {
        var _a, _b;
        var target = e.target;
        setDonationAmount(parseFloat(target.value));
        var dataOther = (_b = (_a = target).getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'data-other');
        if (dataOther !== null && dataOther !== undefined) {
            setOtherVisible(dataOther === 'true');
        }
        checkSeedcardReady();
    };
    var checkSeedcardReady = function () {
        var ready = senderName.length > 0 &&
            validator_1.default.isEmail(senderEmail) &&
            recipientName.length > 0 &&
            validator_1.default.isEmail(recipientEmail) &&
            message.length > 0 &&
            message.trim() !== '<p></p>';
        setSeedcardReady(ready);
        return ready;
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        setSubmitAttempted(true);
        console.log('message=' + message);
        var seedcardData = {
            login: userLogin,
            sender_name: senderName,
            sender_email: senderEmail,
            recipient_name: recipientName,
            recipient_email: recipientEmail,
            text: message,
            amount: donationAmount,
            image_path: selectedImage,
            anonymous: anonymous ? 1 : 0,
        };
        if (checkSeedcardReady() && donationAmount > 0) {
            onSaveSeedcard(seedcardData);
        }
        else {
            setSeedcardReady(false);
            if (message.length === 0 || message.trim() === '<p></p>') {
                scrollToMessage();
            }
            console.warn(seedcardData);
        }
    };
    var donationButtons = [
        { label: '$5', value: 5.00 },
        { label: '$10', value: 10.00 },
        { label: '$20', value: 20.00 },
        { label: '$50', value: 50.00 },
        { label: '$100', value: 100.00 },
        { label: (0, Lang_js_1.__)('Other'), value: 1.00, isOther: true },
    ];
    return (react_1.default.createElement(material_1.Box, { id: "seedcard-form" },
        (gettingUserData || gettingPastRecipients) && react_1.default.createElement(material_1.CircularProgress, { sx: { m: 4 } }),
        !gettingUserData && (react_1.default.createElement(material_1.Box, { component: "form", onSubmit: handleSubmit, sx: { mb: 4 } },
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 } }, (0, Lang_js_1.__)('Your Information')),
            react_1.default.createElement(material_1.TextField, { label: (0, Lang_js_1.__)('Your Name'), value: senderName, onChange: function (e) { return setSenderName(e.target.value); }, onBlur: function () { return checkSeedcardReady(); }, fullWidth: true, required: true, sx: { mb: 2 } }),
            react_1.default.createElement(material_1.TextField, { label: (0, Lang_js_1.__)('Your Email'), value: senderEmail, onChange: function (e) { return setSenderEmail(e.target.value); }, onBlur: function () { return checkSeedcardReady(); }, type: "email", fullWidth: true, required: true, sx: { mb: 2 } }),
            react_1.default.createElement(material_1.FormGroup, null,
                react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { checked: anonymous }), label: (0, Lang_js_1.__)('Send anonymously (contact details still required for your receipt)'), onChange: function (e) { return setAnonymous(e.target.checked); } })),
            !gettingPastRecipients && (pastRecipients === null || pastRecipients === void 0 ? void 0 : pastRecipients.length) > 0 && (react_1.default.createElement(material_1.Box, { id: "past-recipients" },
                react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 } }, (0, Lang_js_1.__)('Select a past recipient')),
                react_1.default.createElement(material_1.TextField, { label: (0, Lang_js_1.__)('Past Recipients'), select: true, defaultValue: "", fullWidth: true, sx: { mb: 2, border: 1, borderColor: 'grey.300', borderRadius: 1, backgroundColor: 'background.paper' }, onChange: function (e) {
                        var recipient = pastRecipients.find(function (_r, index) { return index === Number(e.target.value); });
                        if (recipient) {
                            setRecipientName(recipient.recipient_name);
                            setRecipientEmail(recipient.recipient_email);
                        }
                    } }, pastRecipients.map(function (recipient, index) { return (react_1.default.createElement(material_1.MenuItem, { key: index, value: index },
                    "\"",
                    recipient.recipient_name,
                    "\" ",
                    '<',
                    recipient.recipient_email,
                    '>')); })),
                react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 } }, (0, Lang_js_1.__)('Or enter a new recipient')))),
            !((pastRecipients === null || pastRecipients === void 0 ? void 0 : pastRecipients.length) > 0) && (react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 } }, (0, Lang_js_1.__)("Recipient's Information"))),
            react_1.default.createElement(material_1.TextField, { label: (0, Lang_js_1.__)("Recipient's Name"), value: recipientName, onChange: function (e) { return setRecipientName(e.target.value); }, onBlur: function () { return checkSeedcardReady(); }, fullWidth: true, required: true, sx: { mb: 2 } }),
            react_1.default.createElement(material_1.TextField, { label: (0, Lang_js_1.__)("Recipient's Email"), value: recipientEmail, onChange: function (e) { return setRecipientEmail(e.target.value); }, onBlur: function () { return checkSeedcardReady(); }, type: "email", fullWidth: true, required: true, sx: { mb: 2 } }),
            !senderEmail && !((pastRecipients === null || pastRecipients === void 0 ? void 0 : pastRecipients.length) > 0) && (react_1.default.createElement(material_1.Typography, { variant: "body2", sx: { textAlign: { md: 'end' } } },
                react_1.default.createElement(material_1.Box, { component: "a", href: "/app/students/login?previous_url=/app/seedcard", sx: { fontWeight: 'bold' } }, (0, Lang_js_1.__)('Hint: log in to save and re-use past recipients')))),
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 }, ref: messageRef }, (0, Lang_js_1.__)('Write a Message')),
            react_1.default.createElement(material_1.Box, { sx: __assign({ p: 2 }, (submitAttempted && (message.length === 0 || message.trim() === '<p></p>') && {
                    border: 1,
                    borderColor: 'error.main',
                    borderRadius: 1,
                })) },
                react_1.default.createElement(HtmlEditor_1.default, { onHtmlEditorStateChange: function (htmlEditorState) {
                        setMessage(htmlEditorState);
                        checkSeedcardReady();
                    } })),
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h6", sx: { mt: 2, mb: 1 } }, (0, Lang_js_1.__)('Donation Amount')),
            react_1.default.createElement(material_1.Box, { sx: __assign({ p: 2 }, (submitAttempted && !(donationAmount >= 1.00) && {
                    border: 1,
                    borderColor: 'error.main',
                    borderRadius: 1,
                })) },
                react_1.default.createElement(material_1.ButtonGroup, { "aria-label": (0, Lang_js_1.__)('Donation Amount'), fullWidth: true },
                    react_1.default.createElement(material_1.Grid, { container: true, direction: "row", spacing: 4, justifyContent: "center", alignItems: "center", sx: { mx: 'auto', width: '20rem' }, className: "seed-donation-box" }, donationButtons.map(function (_a) {
                        var label = _a.label, value = _a.value, isOther = _a.isOther;
                        return (react_1.default.createElement(material_1.Grid, { item: true, xs: 6, key: label },
                            react_1.default.createElement(material_1.Button, { className: "seed-donation-button", value: value, "data-other": isOther ? !otherVisible : false, "data-selected": isOther ? otherVisible : donationAmount === value, onClick: function (e) { return handleDonationChange(e); } }, label)));
                    })))),
            otherVisible && (react_1.default.createElement(TextFieldDollars_1.default, { label: (0, Lang_js_1.__)('Other Amount'), value: donationAmount, onChange: function (e) { return handleDonationChange(e); }, fullWidth: true, required: true, autoFocus: true, sx: { mt: 2 }, id: "otherDonationAmount" })),
            react_1.default.createElement("input", { type: "hidden", name: "image", value: selectedImage !== null && selectedImage !== void 0 ? selectedImage : '' }),
            react_1.default.createElement(material_1.Button, { fullWidth: true, variant: "contained", type: "submit", sx: { mt: 3, mb: 2 }, color: "primary", size: "large" }, (0, Lang_js_1.__)('Next'))))));
};
exports.default = SeedcardForm;
